import type { DicomInfo } from '@/lib/dicom/DicomInfo';

export function dicomFileName(dicomInfo: DicomInfo): string {
    return dicomInfo.file.name;
}
